import type React from 'react';

import {
  AgeAttributeCard,
  GenderAttributeCard,
} from '@vlabs/monokit/shared/ui/atribute-cards';

import st from './AttributesCell.module.sass';

interface FaceAttributesRowProps {
  age?: number | null;
  gender?: number | null;
  children?: React.ReactNode;
}

function getGender(value: number | null | undefined): React.ComponentProps<typeof GenderAttributeCard>['gender'] | undefined {
  if (value === 0 || value === 1 || value === 2 || value === null) return value;

  return undefined;
}

function FaceAttributesRow({
  age = undefined,
  children = null,
  gender = undefined,
}: FaceAttributesRowProps): React.JSX.Element | null {
  const genderValue = getGender(gender);
  const hasChildren = children !== null && children !== undefined && children !== false;
  const hasFaceRow = age !== undefined || genderValue !== undefined || hasChildren;

  if (!hasFaceRow) return null;

  return (
    <div className={st.FaceRow}>
      {age !== undefined && (
        <AgeAttributeCard
          age={age}
          className={st.AttributeCard}
        />
      )}

      {genderValue !== undefined && (
        <GenderAttributeCard
          className={st.AttributeCard}
          gender={genderValue}
        />
      )}

      {children}
    </div>
  );
}

export { FaceAttributesRow };
